module.exports = __webpack_public_path__ + "img/lab-2.9f7850b2.png";